import { PapiDeviation } from '@wix/da-papi-types';

export enum DeviationTypes {
  UNKNOWN = 'unknown',
  IMAGE = 'image',
  JOURNAL = 'journal',
  LITERATURE = 'literature',
  FILM = 'film',
  PDF = 'pdf',
  POLL = 'poll',
  COMMISSION = 'commission',
  STATUS = 'status',
  TIER = 'tier',
  ORIGINALS = 'originals',
}

export enum DeviationResourceType {
  UNKNOWN = 0,
  ART = 1,
  JOURNAL = 5,
  SITE_POLL = 6,
  POLL = 14,
  COMMISSION = 66,
  STATUS = 69,
  STATUS_DEVIATION = 81,
  TIER = 82,
  ORIGINALS = 91,
}

export type DeviationPcp = NonNullable<
  NonNullable<PapiDeviation['extended']>['pcp']
>;

export enum DeviationSuggestionReasons {
  WatchingUser = 1,
  WatchingGroup = 2,
  WatchingTopic = 3,
  Recommended = 4,
  DailyDeviation = 5,
  NewDeviant = 6,
  Popular = 7,
  Boosted = 8,
}

export enum DeviationMatureContentType {
  SAFE = 'safe',
  MODERATE = 'moderate',
  STRICT = 'strict',
}

export enum DeviationAccessSettingsType {
  ALL = 'all',
  FUTURE_ONLY = 'future_only',
  LIMITED_PAST_AND_FUTURE = 'limited_past_and_future',
}

/**
 * What a deviation can be sold as.
 *
 * The mapped string values are exact matches for what the backend returns in {@link PapiDeviation}'s
 * extended.sellable_as field. Change them with caution.
 */
export enum SellableAs {
  Adoptable = 'adoptable',
  AdoptableResale = 'adoptable_resale',
  Pcp = 'pcp',
}
